export default __webpack_public_path__ + "static/media/arrow_gray_down.0cd663b8.svg";